import { render, staticRenderFns } from "./SpouseOverview.vue?vue&type=template&id=5a11a259&scoped=true"
import script from "./SpouseOverview.vue?vue&type=script&lang=js"
export * from "./SpouseOverview.vue?vue&type=script&lang=js"
import style0 from "./SpouseOverview.vue?vue&type=style&index=0&id=5a11a259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a11a259",
  null
  
)

export default component.exports